import React from 'react';
import AboutUsContainer from '../../../Containers/UserContainer/AboutUs';
const AboutUsScreen = () => {
  return <AboutUsContainer />;
};

export default AboutUsScreen;
